module.exports = __webpack_public_path__ + "static/media/reg-job.b5c71c16.svg";